import type { Moderator } from "@/entities/moderator/model";

export interface Candidate {
  _id: string;
  referer: string;
  link: string;
  tgUsername: string;
  tgNickname: string;
  tgId: number;
  status: CandidateStatus;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
  survey: Survey;
  moderator: Pick<Moderator, "_id" | "username">;
}

export enum CandidateStatus {
  Pending = "pending",
  Approved = "approved",
  Rejected = "rejected",
}

export interface Survey {
  hasTrafficSearchExperience: boolean;
  trafficSearchExperienceDetails: string;
  hasTrafficProcessingExperience: boolean;
  dedicatedTimeForJob: string;
}
